import React, { useEffect, useRef, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/scss/image-gallery.scss";

import SvgIcon from "../../../SharedComponents/Icons";

import './index.sass';


const FullScreenGallery = ({ data, handleClose, startIndex }) => {

  const [orientationHorizontalMobile, setOrientationHorizontalMobile] = useState(false);

  let gallery = useRef();

  useEffect(() => {
    if (isMobileOnly) {
      window.innerHeight < window.innerWidth && setOrientationHorizontalMobile(true);
      window.addEventListener('orientationchange', handleOrientationChange);
    }

    return () => isMobileOnly && window.removeEventListener('orientationchange', handleOrientationChange);
  }, []);


  const handleOrientationChange = () => {
    setOrientationHorizontalMobile(prevState => !prevState);
  };


  const renderCustomControls = () =>
    <div className="image-gallery-close-button" onClick={handleClose}>
      <SvgIcon name="close" size={24} />
    </div>;


  const renderRightNav = (onClick) =>
    <div
      className='image-gallery-custom-right-nav'
      onClick={onClick} >
      <SvgIcon name="gallery_right" size={64} />
    </div>;


  const renderLeftNav = (onClick) =>
    <div
      className='image-gallery-custom-left-nav'
      onClick={onClick} >
      <SvgIcon name="gallery_left" size={64} />
    </div>;


  return (
    <div className="full-screen">
      <ImageGallery
        additionalClass={orientationHorizontalMobile ? 'horizontal-mobile' : ''}
        fullscreen={false}
        infinite={true}
        items={data}
        ref={(el) => gallery.current = el}
        renderCustomControls={renderCustomControls}
        renderLeftNav={renderLeftNav}
        renderRightNav={renderRightNav}
        showFullscreenButton={false}
        showIndex={true}
        showPlayButton={false}
        showThumbnails={true}
        startIndex={startIndex}
      />
    </div>
  )
};


export default FullScreenGallery;
